import { Inertia } from '@inertiajs/inertia'
import { Component, Event, EventEmitter, Fragment, h, Prop, State } from '@stencil/core'
import Axios from 'axios'
import { flashToast } from 'src/app/toast'

@Component({
  tag: 'ai-search-submit-new-search-button',
})
export class SubmitNewSearchButton {
  @Event({ bubbles: false }) searchSubmitted: EventEmitter<string>
  @Prop() createQueryUrl: string
  @Prop() query: string

  @State() loading = false

  async submitAiSearch() {
    this.loading = true
    try {
      const response = await Axios.post(this.createQueryUrl, { query: this.query })
      if (response.data?.aiCallSearchResultQueryUrl) {
        Inertia.visit(response.data.aiCallSearchResultQueryUrl)
      }
      this.searchSubmitted.emit(this.query)
    } catch (error) {
      flashToast({ type: 'alert', text: 'Failed to search' })
    } finally {
      this.loading = false
    }
  }

  render() {
    return (
      <button
        type='button'
        class='flex justify-between py-8px px-2 w-full text-md font-semibold text-left text-white bg-gray-700 hover:bg-gray-500 rounded-md'
        onClick={(e) => {
          e.stopPropagation()
          this.submitAiSearch()
        }}
        disabled={this.loading}
      >
        {this.loading ? (
          <Fragment>
            <span class='mr-2'>Searching…</span>
            <ui-spinner class='w-4 h-4' />
          </Fragment>
        ) : (
          <Fragment>
            <span class='flex gap-x-1 items-center'>
              Find Matching Moments Using AI <ui-icon icon='stars' class='text-info-warn' />
            </span>
            <span class='py-1px px-1 text-xs font-extrabold text-info-warn uppercase bg-info-warn bg-opacity-20 rounded'>
              New
            </span>
          </Fragment>
        )}
      </button>
    )
  }
}
